export const ru = {
  app: {
    name: 'Lumo',
    tagline: 'Бесконечная доска для совместной работы',
  },
  common: {
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    close: 'Закрыть',
    loading: 'Загрузка…',
    retry: 'Повторить',
    copy: 'Копировать',
    copied: 'Скопировано',
    back: 'Назад',
    more: 'Ещё',
    search: 'Поиск',
    done: 'Готово',
    soon: 'скоро',
    untitled: 'Без названия',
  },
  theme: {
    label: 'Тема',
    light: 'Светлая',
    dark: 'Тёмная',
    system: 'Системная',
  },
  time: {
    justNow: 'только что',
  },
  errors: {
    notFound: 'Страница не найдена',
    notFoundHint: 'Возможно, ссылка устарела или доска была удалена.',
    generic: 'Что-то пошло не так',
    toHome: 'На главную',
  },
  tools: {
    select: 'Выделение',
    hand: 'Рука',
    sticky: 'Стикер',
    shape: 'Фигура',
    text: 'Текст',
    pen: 'Перо',
    highlighter: 'Маркер',
    eraser: 'Ластик',
    connector: 'Соединительная линия',
    frame: 'Фрейм',
    image: 'Изображение',
    card: 'Карточка',
    table: 'Таблица',
    mindmap: 'Mind map',
    comment: 'Комментарий',
    stamp: 'Штамп',
    laser: 'Лазерная указка',
    undo: 'Отменить',
    redo: 'Повторить',
    lockHint: 'Двойной клик — закрепить инструмент',
  },
  shapes: {
    rect: 'Прямоугольник',
    rounded: 'Скруглённый',
    ellipse: 'Круг',
    diamond: 'Ромб',
    triangle: 'Треугольник',
    star: 'Звезда',
    hexagon: 'Шестиугольник',
    arrow: 'Стрелка',
    cloud: 'Облако',
    cylinder: 'Цилиндр',
    parallelogram: 'Параллелограмм',
  },
  sticky: {
    size: 'Размер',
    sizeS: 'S',
    sizeM: 'M',
    sizeL: 'L',
    color: 'Цвет стикера',
    showAuthor: 'Показывать автора',
  },
  zoom: {
    in: 'Приблизить',
    out: 'Отдалить',
    fit: 'Показать всё',
    reset: 'Масштаб 100%',
    toSelection: 'К выделению',
    minimap: 'Миникарта',
  },
  context: {
    color: 'Цвет',
    fill: 'Заливка',
    stroke: 'Обводка',
    strokeWidth: 'Толщина',
    strokeStyle: 'Стиль линии',
    solid: 'Сплошная',
    dashed: 'Пунктир',
    dotted: 'Точки',
    font: 'Шрифт',
    fontSize: 'Размер шрифта',
    autoSize: 'Авто',
    align: 'Выравнивание',
    alignLeft: 'По левому краю',
    alignCenter: 'По центру',
    alignRight: 'По правому краю',
    valignTop: 'Сверху',
    valignMiddle: 'Посередине',
    valignBottom: 'Снизу',
    textColor: 'Цвет текста',
    shapeKind: 'Тип фигуры',
    layers: 'Слои',
    bringToFront: 'На передний план',
    bringForward: 'Выше',
    sendBackward: 'Ниже',
    sendToBack: 'На задний план',
    lock: 'Заблокировать',
    unlock: 'Разблокировать',
    duplicate: 'Дублировать',
    delete: 'Удалить',
    group: 'Сгруппировать',
    ungroup: 'Разгруппировать',
    alignObjects: 'Выровнять',
    alignObjLeft: 'По левому краю',
    alignObjCenterX: 'По центру по горизонтали',
    alignObjRight: 'По правому краю',
    alignObjTop: 'По верхнему краю',
    alignObjMiddle: 'По центру по вертикали',
    alignObjBottom: 'По нижнему краю',
    distributeH: 'Распределить по горизонтали',
    distributeV: 'Распределить по вертикали',
    more: 'Ещё',
    bold: 'Жирный',
    italic: 'Курсив',
    underline: 'Подчёркнутый',
    strike: 'Зачёркнутый',
    link: 'Ссылка',
    bulletList: 'Маркированный список',
    background: 'Фон',
    none: 'Нет',
    copy: 'Копировать',
    paste: 'Вставить',
    cut: 'Вырезать',
    selected: '{count|объект|объекта|объектов}',
  },
  board: {
    untitled: 'Новая доска',
    rename: 'Переименовать',
    menu: 'Меню доски',
    share: 'Поделиться',
    comments: 'Комментарии',
    present: 'Презентация',
    timer: 'Таймер',
    voting: 'Голосование',
    grid: 'Сетка',
    gridDots: 'Точки',
    gridLines: 'Линии',
    gridNone: 'Без сетки',
    snapToGrid: 'Привязка к сетке',
    shortcuts: 'Горячие клавиши',
    backToDashboard: 'Ко всем доскам',
    localMode: 'Локальная доска',
    hideUi: 'Скрыть интерфейс',
    showUi: 'Показать интерфейс',
  },
  dashboard: {
    allBoards: 'Все доски',
    recent: 'Недавние',
    favorites: 'Избранное',
    shared: 'Общие со мной',
    templates: 'Шаблоны',
    trash: 'Корзина',
    projects: 'Проекты',
    newProject: 'Новый проект',
    projectName: 'Название проекта',
    renameProject: 'Переименовать проект',
    deleteProject: 'Удалить проект',
    newBoard: 'Новая доска',
    import: 'Импорт',
    importTooLarge: 'Файл больше 20 МБ',
    importNotJson: 'Это не JSON-файл экспорта',
    blankBoard: 'Пустая доска',
    quickStart: 'Быстрый старт',
    searchBoards: 'Поиск досок',
    sortUpdated: 'По изменению',
    sortName: 'По названию',
    sortCreated: 'По созданию',
    viewGrid: 'Сеткой',
    viewList: 'Списком',
    open: 'Открыть',
    rename: 'Переименовать',
    duplicate: 'Дублировать',
    moveTo: 'Переместить в проект',
    noProject: 'Без проекта',
    addFavorite: 'В избранное',
    removeFavorite: 'Убрать из избранного',
    toTrash: 'В корзину',
    restore: 'Восстановить',
    deleteForever: 'Удалить навсегда',
    deleteForeverConfirm: 'Доска и все её версии будут удалены без возможности восстановления.',
    updated: 'Изменено {time}',
    deleted: 'Удалено {time}',
    owner: 'Владелец',
    name: 'Название',
    emptyAll: 'Здесь пока пусто',
    emptyAllText: 'Создайте первую доску — стикеры, схемы и идеи ждут.',
    emptyFavorites: 'Нет избранных досок',
    emptyFavoritesText: 'Отмечайте звёздочкой доски, к которым часто возвращаетесь.',
    emptyRecent: 'Вы ещё не открывали доски',
    emptyShared: 'С вами пока ничем не поделились',
    emptySharedText: 'Доски, на которые вас пригласят, появятся здесь.',
    emptyTrash: 'Корзина пуста',
    emptyTrashText: 'Удалённые доски хранятся здесь 30 дней.',
    emptySearch: 'Ничего не нашлось',
    emptySearchText: 'Попробуйте другой запрос.',
    trashHint: 'Доски удаляются навсегда через 30 дней.',
    workspaces: 'Воркспейсы',
    newWorkspace: 'Новый воркспейс',
    workspaceName: 'Название воркспейса',
    workspaceSettings: 'Настройки воркспейса',
    profile: 'Профиль',
    explore: 'Галерея',
    developers: 'Разработчикам',
    personal: 'Личное',
    members: '{count|участник|участника|участников}',
    boardsCount: '{count|доска|доски|досок}',
  },
  share: {
    title: 'Поделиться доской',
    invite: 'Пригласить',
    invitePlaceholder: 'Email коллеги',
    people: 'Люди с доступом',
    generalAccess: 'Общий доступ',
    private: 'Только приглашённые',
    privateHint: 'Доска видна только вам и тем, кого вы пригласили',
    workspace: 'Все в воркспейсе',
    workspaceHint: 'Участники воркспейса могут редактировать',
    link: 'Все, у кого есть ссылка',
    linkHint: 'Доступ без входа по ссылке',
    public: 'Публичная доска',
    publicHint: 'Видна всем в интернете, можно встроить на сайт',
    linkRole: 'Роль по ссылке',
    copyLink: 'Скопировать ссылку',
    linkCopied: 'Ссылка скопирована',
    password: 'Пароль на ссылку',
    passwordSet: 'Пароль установлен',
    passwordRemove: 'Снять пароль',
    expires: 'Срок действия',
    never: 'Бессрочно',
    day: '1 день',
    week: '7 дней',
    month: '30 дней',
    expiresAt: 'до {date}',
    rotate: 'Сбросить ссылку',
    publicUrl: 'Публичный адрес',
    listed: 'Показывать в галерее',
    listedHint: 'Доска появится на странице /explore',
    allowDuplicate: 'Разрешить копировать к себе',
    tags: 'Теги',
    tagsPlaceholder: 'Через запятую: ретро, продукт',
    embed: 'Встроить на сайт',
    embedCopy: 'Скопировать код',
    pending: 'Приглашение отправлено',
    remove: 'Убрать доступ',
    leave: 'Покинуть доску',
    roles: {
      owner: 'Владелец',
      editor: 'Редактор',
      commenter: 'Комментатор',
      viewer: 'Зритель',
    },
  },
  auth: {
    loginTitle: 'С возвращением',
    loginSubtitle: 'Войдите, чтобы продолжить работу с досками.',
    registerTitle: 'Создайте аккаунт',
    registerSubtitle: 'Бесплатно и без ограничений. Все функции доступны всем.',
    email: 'Email',
    password: 'Пароль',
    name: 'Имя',
    namePlaceholder: 'Как вас называть',
    passwordHint: 'Минимум 8 символов',
    login: 'Войти',
    register: 'Создать аккаунт',
    noAccount: 'Нет аккаунта?',
    haveAccount: 'Уже есть аккаунт?',
    forgot: 'Забыли пароль?',
    forgotTitle: 'Сброс пароля',
    forgotSubtitle: 'Пришлём ссылку для создания нового пароля.',
    forgotSend: 'Отправить ссылку',
    forgotSent: 'Если такой email зарегистрирован, письмо уже в пути. Проверьте почту.',
    resetTitle: 'Новый пароль',
    resetSave: 'Сохранить пароль',
    newPassword: 'Новый пароль',
    backToLogin: 'Вернуться ко входу',
    orContinue: 'или',
    withGithub: 'Войти через GitHub',
    withGoogle: 'Войти через Google',
    logout: 'Выйти',
    showPassword: 'Показать пароль',
    hidePassword: 'Скрыть пароль',
  },
  sync: {
    online: 'Онлайн',
    connecting: 'Подключение…',
    reconnecting: 'Переподключение…',
    offline: 'Офлайн — изменения сохранятся и отправятся позже',
    offlineShort: 'Офлайн',
    synced: 'Все изменения сохранены',
    readOnly: 'Только просмотр',
    commentOnly: 'Только комментарии',
    follow: 'Следовать',
    stopFollow: 'Перестать следовать',
    following: 'Вы следуете за {name}',
    goTo: 'Перейти к вьюпорту',
    summon: 'Собрать всех ко мне',
    summoned: '{name} собирает всех у себя',
    participants: 'Участники',
    you: 'вы',
    guest: 'Гость',
    accessDenied: 'Нет доступа к доске',
    limit: 'Достигнут лимит',
  },
  shortcuts: {
    title: 'Горячие клавиши',
    tools: 'Инструменты',
    edit: 'Редактирование',
    view: 'Вид',
    navigation: 'Навигация',
    pan: 'Панорама',
    panHint: 'Пробел + перетаскивание, средняя кнопка',
    zoom: 'Масштаб',
    zoomHint: 'Ctrl + колесо, щипок на трекпаде',
    undo: 'Отменить',
    redo: 'Повторить',
    selectAll: 'Выделить всё',
    duplicate: 'Дублировать',
    group: 'Сгруппировать',
    ungroup: 'Разгруппировать',
    lock: 'Заблокировать',
    delete: 'Удалить',
    nudge: 'Сдвинуть на 1 / 10 px',
    editText: 'Редактировать текст',
    bringForward: 'Выше / ниже',
    bringToFront: 'На передний / задний план',
    fit: 'Показать всё',
    toSelection: 'К выделению',
    zoom100: 'Масштаб 100%',
    zoomInOut: 'Приблизить / отдалить',
    palette: 'Командная палитра',
    help: 'Эта шпаргалка',
    hideUi: 'Скрыть интерфейс',
    multiSelect: 'Добавить к выделению',
    resizeAspect: 'Пропорционально / от центра',
    rotateSnap: 'Поворот с шагом 15°',
    altDrag: 'Копировать перетаскиванием',
  },
} as const;
